// @flow
import { createReducer } from 'actions';
import { LOAD_TOPICS, LOAD_SINGLE_TOPIC } from 'actions/topics';
import { LOGOUT } from 'actions/auth';
import type { SingleTopic, ZuzuAction } from 'types';
import type {
  Topic,
  LoadTopicsAction,
  LoadSingleTopicAction,
} from 'actions/topics';

type State = {
  all: Array<Topic>,
  singles: { [topicId: string]: SingleTopic },
};

const initialState: State = {
  all: [],
  singles: {},
  error: null,
};

export default createReducer(
  initialState,
  {
    [LOAD_TOPICS]: (state: State, action: LoadTopicsAction) => {
      if (action.meta.done && !action.meta.error && action.payload) {
        return {
          ...state,
          all: [...action.payload],
          error: null,
        };
      }
      return state;
    },

    [LOAD_SINGLE_TOPIC]: (state: State, action: LoadSingleTopicAction) => {
      if (action.meta.done && !action.meta.error && action.payload) {
        return {
          ...state,
          singles: {
            ...state.singles,
            [action.payload.topicId]: action.payload,
          },
          error: null,
        };
      }
      return state;
    },

    [LOGOUT]: () => {
      return { ...initialState };
    },
  },
  (state: State, action: ZuzuAction) => {
    return {
      ...state,
      error: action.payload,
    };
  }
);



// WEBPACK FOOTER //
// ./src/redux/reducers/topics.js